import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CompaniesForm from "../../forms/CompaniesForm";
import {
  selectCompany,
  selectCompanyRegistration
} from "../../../redux/preferences/selectors";
import { connect } from "react-redux";
import { updateCompany } from "../../../services/api/companies";
import { ajaxErrorHandler, defaultSuccess } from "../../../libs/utils";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import SubContractorsForm from "../../forms/SubContractorsForm";
import {
  deleteSubContractor,
  disableSubContractors,
  getSubContractors
} from "../../../services/api/subcontractors";
import { USER_ACTIONS } from "../../../redux/auth/actions";

const _CompanyCompanyDetails = props => {
  const [isCreating, setCreating] = useState(false);
  const [company, setCompany] = useState();
  const [subContractors, setSubContractors] = useState();
  const [subContractorsMeta, setSubContractorsMeta] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getSubContractors(props.registration.id).then(response => {
      setSubContractors(response.data);
      setSubContractorsMeta(response.meta);
    });
  };

  const _handleSubmit = values => {
    setCreating(true);

    const data = {
      name: values.name,
      email: values.email,
      telephone: values.telephone,
      addressLine1: values.address,
      city: values.city,
      zip: values.postal_code,
      country: values.country,
      vat: values.vat,
      type: props.company.type
    };

    updateCompany(props.company.id, data)
      .then(response => {
        defaultSuccess("Thank you for updating your company info.");
        props.refreshUserData();
      })
      .catch(ajaxErrorHandler)
      .then(response => {
        setCompany(response);
        setCreating(false);
      });
  };

  const _handleRequireSubContractorsChange = values => {
    return new Promise((resolve, reject) => {
      disableSubContractors(props.registration.id)
        .then(response => {
          defaultSuccess("updated");
          props.refreshUserData();
          resolve();
        })
        .catch(e => {
          ajaxErrorHandler(e);
          reject();
        });
    });
  };

  const _handleDelete = id => {
    deleteSubContractor(props.registration.id, id)
      .then(response => {
        getData();
        defaultSuccess("Subcontractor Deleted!");
        props.refreshUserData();
      })
      .catch(ajaxErrorHandler);
  };

  const _validate = values => {
    let errors = {};

    if (!values.name || values.name === "") {
      errors.name = "required";
    }

    if (!values.postal_code || values.postal_code === "") {
      errors.postal_code = "required";
    }

    if (!values.address || values.address === "") {
      errors.address = "required";
    }

    if (!values.city || values.city === "") {
      errors.city = "required";
    }

    if (!values.country || values.country === "") {
      errors.country = "required";
    }

    if (!values.vat || values.vat === "") {
      errors.vat = "required";
    }

    return errors;
  };

  const { registration } = props;

  return (
    <>
      <AdminSubHeader title="Company" key="subheader" breadcrumbs={[]} />
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-information" />
                    </span>
                    <h3 className="m-portlet__head-text">Company Info</h3>
                  </div>
                </div>
              </div>
              <CompaniesForm
                onSubmit={_handleSubmit}
                formSubmitting={isCreating}
                company={company ? company : props.company}
                overwriteValidate={_validate}
                hideType
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-information" />
                    </span>
                    <h3 className="m-portlet__head-text">Subcontractors</h3>
                  </div>
                </div>
              </div>

              <SubContractorsForm
                handleDelete={_handleDelete}
                subContractorsMeta={subContractorsMeta}
                subContractors={subContractors}
                registration={registration}
                onSubmit={_handleRequireSubContractorsChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

_CompanyCompanyDetails.propTypes = {
  company: PropTypes.object.isRequired,
  registration: PropTypes.object.isRequired
};

const mapStateToProps = function(state) {
  return {
    company: selectCompany(state),
    registration: selectCompanyRegistration(state)
  };
};

const mapDispatchToProps = dispatch => ({
  refreshUserData: () => dispatch(USER_ACTIONS.getDataRequest())
});

const CompanyCompanyDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(_CompanyCompanyDetails);

export default CompanyCompanyDetails;
